import { Fragment } from 'react'

import { cx } from './cx.ts'

import './feedback.css'

/**
 * 원형 번호 스테퍼 — 와이어프레임 `nstep()` 1016행.
 * 새 작업(시료 → 레시피·배정 → 사전 점검)과 생성된 작업이 같이 쓴다.
 *
 * ⚠ 「시작」 단계를 넣지 마라. 시작은 상단 작업 줄에서만 한다
 *   (와이어프레임 1015행 주석 · eric 지시 2026-09-16).
 */
export type NumberStepperProps = {
  /** 단계 이름(한글) */
  steps: readonly string[]
  /** 현재 단계 인덱스 */
  current: number
  /** 접근성 이름 */
  label: string
}

export function NumberStepper({ steps, current, label }: NumberStepperProps) {
  return (
    <ol aria-label={label} className="a-nstep">
      {steps.map((step, index) => (
        <Fragment key={step}>
          <li
            aria-current={index === current ? 'step' : undefined}
            className={cx(
              'a-nstep__item',
              index < current && 'a-nstep__item--done',
              index === current && 'a-nstep__item--now',
            )}
          >
            <span aria-hidden="true" className="a-nstep__num">
              {index < current ? '✓' : index + 1}
            </span>
            <span>{step}</span>
          </li>
          {index < steps.length - 1 ? <span aria-hidden="true" className="a-nstep__line" /> : null}
        </Fragment>
      ))}
    </ol>
  )
}
